import { MapPin, ArrowUpRight } from "lucide-react";
import { STAY } from "@/constants/testIds";
import { useLang } from "@/i18n/LanguageContext";
import { HOTELS } from "@/data/hotels";
import { HydrangeaFlourish, RoseFlourish } from "@/components/wedding/Flourish";

export const Stay = () => {
  const { t, lang } = useLang();

  return (
    <section id="stay" data-testid={STAY.section} className="relative py-24 sm:py-32 overflow-hidden">
      <HydrangeaFlourish
        className="absolute -top-6 -right-10 w-[100px] sm:w-[140px] md:w-[180px]"
        opacity={0.8}
      />
      <RoseFlourish
        className="absolute -bottom-8 -left-6 w-[100px] sm:w-[140px] md:w-[180px] -rotate-3"
        opacity={0.8}
      />
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-end mb-16">
          <div className="md:col-span-7">
            <h2 className="mt-4 font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter font-light">
              {t("stay.chapter")}
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="font-serif italic text-lg text-black/65 max-w-md">{t("stay.sub")}</p>
            <div className="mt-3 font-overline text-[10px] text-black/50">{t("stay.priceLegend")}</div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-black/10 border border-black/10">
          {HOTELS.map((h) => (
            <a
              key={h.key}
              href={h.href}
              target="_blank"
              rel="noreferrer"
              data-testid={STAY.card(h.key)}
              className="group relative bg-white p-8 sm:p-10 flex flex-col transition-colors hover:bg-black hover:text-white"
            >
              <div className="flex items-start justify-between">
                <div className="font-overline text-[10px] text-[color:var(--rose-600)] group-hover:text-[color:var(--rose-300)]">
                  {h.tag[lang]}
                </div>
                <ArrowUpRight
                  size={18}
                  className="text-black/40 group-hover:text-white group-hover:rotate-45 transition-transform duration-300"
                />
              </div>

              <h3 className="mt-8 font-title text-2xl sm:text-3xl tracking-tighter leading-tight">
                {h.name}
              </h3>

              <p className="mt-3 font-serif italic text-sm sm:text-base text-black/65 group-hover:text-white/75 flex-1">
                {h.note[lang]}
              </p>

              <div className="mt-8 pt-6 border-t border-black/10 group-hover:border-white/15 flex items-center justify-between gap-4">
                <div className="flex items-center gap-2 min-w-0">
                  <MapPin size={14} className="text-[color:var(--rose-500)] shrink-0" />
                  <span className="font-mono-acc text-xs tracking-wide text-black/70 group-hover:text-white/80 truncate">
                    {h.distance[lang]}
                  </span>
                </div>
                <span className="font-mono-acc text-sm tracking-wider text-[color:var(--rose-600)] group-hover:text-[color:var(--rose-300)]">
                  {h.price}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
